import { Component, Input, ViewEncapsulation} from '@angular/core';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { FooterActionBarButtonModel } from '../../../Misc/models/footer-action-bar-button.model';

/** @deprecated */
@Component({
    selector: 'agpr-footer-action-bar',
    templateUrl: './footer-action-bar.component.html',
    styleUrls: ['./footer-action-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FooterActionBarComponent  {
    readonly buttonStyle = ButtonTypesEnum;
    @Input() public id: string;
    @Input() leftButtonGroup: FooterActionBarButtonModel[];
    @Input() rightButtonGroup: FooterActionBarButtonModel[];

    clickEvent(button: FooterActionBarButtonModel) {
        button.click.emit(button);
    }
}
